//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ShowText from "@/0/components/comForm/comDetailControls/comShowText.vue";
import EditHidden from "@/0/components/comForm/comEditControls/comEditHidden.vue";
import ShowTextArea from "@/0/components/comForm/comDetailControls/comShowTextArea.vue";

import ShowCommon from "@/0/components/comForm/comDetailControls/Common/comShowCommon.vue";
import ShowDev01 from "@/0/components/comForm/comDetailControls/Common/comDev01.vue";
import ShowDev02 from "@/0/components/comForm/comDetailControls/Common/comDev02.vue";
import ShowDev03 from "@/0/components/comForm/comDetailControls/Common/comDev03.vue";
import ShowDev04 from "@/0/components/comForm/comDetailControls/Common/comDev04.vue";
import ShowDev05 from "@/0/components/comForm/comDetailControls/Common/comDev05.vue";
import ShowDev06 from "@/0/components/comForm/comDetailControls/Common/comDev06.vue";
import ShowDev07 from "@/0/components/comForm/comDetailControls/Common/comDev07.vue";

import ShowHtml from "@/0/components/comForm/comDetailControls/comShowHtml.vue";
import ShowEditor from "@/0/components/comForm/comDetailControls/comShowEditor.vue";

import ShowTable from "@/0/components/comForm/comDetailControls/comShowTable.vue";

import ShowImage from "@/0/components/comForm/comDetailControls/comShowImage.vue";
import ShowImagesList from "@/0/components/comForm/comDetailControls/comShowImagesList.vue";

import ShowFile from "@/0/components/comForm/comDetailControls/comShowFile.vue";
import ShowFilesList from "@/0/components/comForm/comDetailControls/comShowFilesList.vue";

import AddmenDoload from "@/0/components/comForm/comEditControls/comAddmenDoload.vue";
import ShowSteps from "@/0/components/comForm/comEditControls/comEditSteps.vue";
import ShowStepsH from "@/0/components/comForm/comEditControls/comEditStepsH.vue";

import ShowMap from "@/0/components/comForm/comDetailControls/comShowMap.vue";
import ShowMapTrack from "@/0/components/comForm/comDetailControls/comShowMapTrack.vue";

export default {
  props: ["groupBoxViewList", "dataConfig"],
  components: {
    "edit-hidden": EditHidden,
    "show-text": ShowText,
    "show-text-area": ShowTextArea,

    "show-common": ShowCommon,
    "show-dev01": ShowDev01,
    "show-dev02": ShowDev02,
    "show-dev03": ShowDev03,
    "show-dev04": ShowDev04,
    "show-dev05": ShowDev05,
    "show-dev06": ShowDev06,
    "show-dev07": ShowDev07,

    "show-html": ShowHtml,
    "show-editor": ShowEditor,

    "show-image": ShowImage,
    "show-images-list": ShowImagesList,

    "show-file": ShowFile,
    "show-files-list": ShowFilesList,

    "show-table": ShowTable,

    "addmen-doload": AddmenDoload,
    "show-steps": ShowSteps,
    "show-stepsH": ShowStepsH,

    "show-map": ShowMap,
    "show-map-track": ShowMapTrack
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    $getComPage() {
      return this.$parent.$getComPage();
    },

    $getSubmitData() {
      var formData = {};

      return formData;
    },
    getSubmitData() {
      return this.$getSubmitData();
    }
  }
};
